import React,{ Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'; 
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import './custom_responsive.css';


import Navbar from './components/Navbar';
import Footer from './components/Footer';
const Home = React.lazy(() => import("./pages/Home"));
const AboutUs = React.lazy(() => import("./pages/AboutUs"));
const OurStory = React.lazy(() => import("./pages/OurStory"));
const OurPromises = React.lazy(() => import("./pages/OurPromises"));
const Certification = React.lazy(() => import("./pages/Certification"));
const Catalogue = React.lazy(() => import("./pages/Catalogue"));
const OurVideos = React.lazy(() => import("./pages/OurVideos"));
const OurClients = React.lazy(() => import("./pages/OurClients"));
const Contact = React.lazy(() => import("./pages/Contact"));
const Exhibition = React.lazy(() => import("./pages/Exhibition"));
const ProductDetail = React.lazy(() => import("./pages/ProductDetail"));
const RouteResolver = React.lazy(() => import("./pages/RouteResolver"));
const Sitemap = React.lazy(() => import("./pages/Sitemap"));

function App() {
 
  return (
    <Router>
      <div className="App">
        <Suspense fallback={<div>Loading...</div>}>
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} /> 
          <Route path="/about-us" element={<AboutUs />} /> 
          <Route path="/our-story" element={<OurStory />} /> 
          <Route path="/our-promises" element={<OurPromises />} /> 
          <Route path="/certification" element={<Certification />} /> 
          <Route path="/catalogue" element={<Catalogue />} /> 
          <Route path="/our-videos" element={<OurVideos />} /> 
          <Route path="/our-clients" element={<OurClients />} /> 
          <Route path="/contact-us" element={<Contact />} /> 
          <Route path="/exhibition" element={<Exhibition />} /> 
          <Route path="/sitemap" element={<Sitemap />} />
          <Route path="/product-detail/:categoryId" element={<ProductDetail />} /> 
          <Route path="/product-detail" element={<ProductDetail />} /> 
          {/* <Route path="/product/:id" element={<ProductSingleDetail />} /> */}
          {/* <Route path="/subcategory/:slug" element={<SubCategory />} /> */}
          <Route path="/*" element={<RouteResolver />} />
        </Routes>
        <Footer />
        </Suspense>
      </div>
    </Router>
  );
}

export default App;
